/**
 * Extracted from sections/ns-header-new-plunge.liquid (inline <script> blocks at lines 587, 613, 649).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/ns-header-new-plunge.liquid:587) ---
(function () {
let allFirstLevelButtons = document.querySelectorAll('button.level-one-button');
let customBackButton = document.querySelector(".navigation-header-back-button");
allFirstLevelButtons.forEach((el) => {
  el.addEventListener("click", () => {
    document.querySelector(".navigation-header").querySelector(".header__logo").setAttribute("style", "display:none;");
    document.querySelector(".navigation-header-back-heading").classList.add("active");
    let customIndex = el.getAttribute("data-panel").slice(-1)
    document.querySelector(".navigation-header-back-heading").innerHTML = document.querySelectorAll(".back-button-custom")[customIndex].textContent.trim();
    customBackButton.classList.add("active");
  })
})
customBackButton.addEventListener("click", () => {
  document.querySelector(".back-button-custom").firstElementChild.click()
  document.querySelector(".navigation-header").querySelector(".header__logo").removeAttribute("style");
  document.querySelector(".navigation-header-back-heading").classList.remove("active");
  customBackButton.classList.remove("active");
}) 
document.addEventListener("button:custom-clicked", ()=> {
  document.querySelector(".navigation-header").querySelector(".header__logo").removeAttribute("style");
  document.querySelector(".navigation-header-back-heading").classList.remove("active");
  customBackButton.classList.remove("active");
});
  
})();

// --- original inline block #2 (was at sections/ns-header-new-plunge.liquid:613) ---
(function () {
// -----------------------------------------------------------------
// script for working of 'accordion closure' if another gets opened.
document.addEventListener("DOMContentLoaded", () => {
  let navDrawer = document.querySelector('navigation-drawer.navigation-drawer-fa ')
  let accordionFlag = true
  function accordionAutoClosure() {
    let allAccordionEls = navDrawer.querySelectorAll('details.accordion summary')
    if (allAccordionEls) {
      allAccordionEls.forEach(accordion => accordion.addEventListener('click', (e) => {
        if (accordionFlag == true) {
          accordionAutoClosureFn(accordion)
        }
      }))
    }
  }
  
  function accordionAutoClosureFn(clickedAccordion) {
    let openedAccordionEls = navDrawer.querySelectorAll('details.accordion[aria-expanded="true"] summary')
    if (openedAccordionEls) {
      accordionFlag = false
      openedAccordionEls.forEach(el => {
        if (el != clickedAccordion) {
          el.click()
        }
      })
    }
    accordionFlag = true
    clickedAccordion.querySelector('summary').click()
  }
  
  accordionAutoClosure()
});
})();

// --- original inline block #3 (was at sections/ns-header-new-plunge.liquid:649) ---
(function () {
// ------------------------------------------
// script for working of 'mega_menu_grid'
document.addEventListener("DOMContentLoaded", () => {
  function listMegaMenuInit() {
    let desktopMegaMenuListEls = document.querySelectorAll('.mega-menu.mega_menu_list')
    let mobileMegaMenuListEls = document.querySelectorAll('.ns-mb-mm-list.mega_menu_list')
    
    if (desktopMegaMenuListEls) {
      desktopMegaMenuListEls.forEach((menu) => {
          desktopListMegaMenuInit(menu)
      })
    }

    if (mobileMegaMenuListEls) {
      mobileMegaMenuListEls.forEach((menu) => { 
          mobileListMegaMenuInit(menu)
          // syncScrollBadgesInit(menu)

          let scrollDiv1 = menu.querySelector(".ns-mb-mm-list__titles-content-wrapper");
          let scrollDiv2 = menu.querySelector(".ns-mb-mm-list__titles-badges-wrapper");

          if (scrollDiv1 && scrollDiv2) {
            scrollDiv1.addEventListener("scroll", () => {
              syncScroll()
            });
            
            function syncScroll() {
              scrollDiv2.scrollLeft = scrollDiv1.scrollLeft;
            }
          }
          
      })
    }
    
    function desktopListMegaMenuInit(menu) {
      let allListItemTitleEls = menu.querySelectorAll('[data-mega-menu-list-title-index]')
      let allListItemListEls = menu.querySelectorAll('[data-mega-menu-list-list-index]')

      if (allListItemTitleEls) {
        allListItemTitleEls.forEach(title => title.addEventListener('mouseenter', () => {
          updateDisplayOfListItem(title, menu, allListItemTitleEls, allListItemListEls) 
        }))
      }
    }

    function mobileListMegaMenuInit(menu) {
      let allListItemTitleEls = menu.querySelectorAll('[data-mega-menu-list-title-index]')
      let allListItemListEls = menu.querySelectorAll('[data-mega-menu-list-list-index]')

      if (allListItemTitleEls) {
        allListItemTitleEls.forEach(title => title.addEventListener('click', () => {
          updateDisplayOfListItem(title, menu, allListItemTitleEls, allListItemListEls) 
        }))
      }
    }

    function updateDisplayOfListItem(title, menu, titles, lists) { 
      console.log('inside fn updateDisplayOfListItem')
      let index = +title.getAttribute('data-mega-menu-list-title-index')
      console.log('index', index)
    
      if (lists && index != undefined) {
          titles.forEach(el => el.classList.remove('active'))
          titles[index].classList.add('active')

          lists.forEach(el => el.classList.remove('active'))
          lists[index].classList.add('active')
      }
    }
    
    function syncScrollBadgesInit(menu) {}
  }

  listMegaMenuInit()
});
})();
